import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-refresh-tooltip',
  templateUrl: './refresh-tooltip.component.html',
  styleUrls: ['./refresh-tooltip.component.scss'],
})
export class RefreshTooltipComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
